import type React from 'react';

export const ENTER_KEY = 'Enter';
export const ESCAPE_KEY = 'Escape';
export const WHITESPACE_KEY = ' ';
export const SUPPORT_BACK_BUTTON = 'pushIn';

const buildHandleEnterAndSpaceKeyPress =
  (onClick?: () => void) => (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === ENTER_KEY || event.key === WHITESPACE_KEY) {
      event.preventDefault();

      if (onClick) {
        onClick();
        return;
      }

      event.currentTarget.click();
    }
  };

export const linkPropsWithKeyboardNavigation = (onClick?: () => void) => ({
  onClick,
  tabIndex: 0,
  onKeyDown: buildHandleEnterAndSpaceKeyPress(onClick),
});

export default buildHandleEnterAndSpaceKeyPress;
